export { TildaComponent } from "./TildaComponent";
export type { Tilda } from "./TildaComponent";